const isArray = value => {
	return Array.isArray(value);
};

export default isArray;